import type { Node } from 'ricos-schema';

import type { ImagePluginViewerConfig } from '../types';

export type ImageClickActionHandle = (e: React.MouseEvent | React.KeyboardEvent) => void;

export type ImageClickActionConfig =
  | {
      type: 'link' | 'anchor' | 'regular';
    }
  | {
      type: 'expand';
      onClick: ImageClickActionHandle;
    };

export const getImageClickActionConfig = ({
  imageData,
  config,
  expand,
}: {
  imageData: Node['imageData'];
  config?: ImagePluginViewerConfig;
  expand?: ImageClickActionHandle;
}): ImageClickActionConfig => {
  if (imageData?.link?.url && config) {
    return { type: 'link' };
  }

  if (imageData?.link?.anchor) {
    return { type: 'anchor' };
  }

  if (expand) {
    return { type: 'expand', onClick: expand };
  }

  return { type: 'regular' };
};
